export default __webpack_public_path__ + "static/media/orphanswords-ascent-04.31680c2d.jpg";